<div class="contentview contentHeight">
    <div class="mainCtn">
        <table mat-table class="borderBlue backgroundWhiteRound" [dataSource]="keys">
            <ng-container matColumnDef="maj">
                <th mat-header-cell class="blue" *matHeaderCellDef>{{'actionmateriel.maj'|translate}}</th>
                <td mat-cell *matCellDef="let res">{{res}}</td>
            </ng-container>
            <ng-container matColumnDef="dl">
                <th mat-header-cell class="blue" *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let res">
                    <button class="btn btn-secondary mt-0" (click)="dl(res)" title="{{'common.majDownload'|translate}}">
                        <i aria-hidden="true" class="fa fa-download fa-black-tie"></i>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columns"></tr>

            <tr mat-row *matRowDef="let row; columns: columns"></tr>
        </table>
    </div>
</div>
